const backend='https://www.astrofi.com';

export default {
	siteKey:'6LforOIUAAAAACmWCczlU2rX1TCJXuQ0oUw0Tn9l',
	backend
}